import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";

export const getPublicHolidays = async (customerId, region = "", year = null) => {
  let requestPath;

  requestPath = `${baseUrl}/public-holidays`;
  const params = [];
  if (region) {
    params.push(`region=${region}`);
  }
  if (year) {
    params.push(`year=${year}`);
  }
  if (params.length > 0) {
    requestPath += `?${params.join("&")}`;
  }

  const { payload } = await getRequest(requestPath);

  if (payload?.error) {
    throw new Error(payload?.error[0]?.description);
  }

  return payload;
};

export const getCalendarLinks = async (customerId) => {
  const requestPath = `${baseUrl}/customer/${customerId}/holidayCalendarSyncLinks`;

  const { payload } = await getRequest(requestPath);

  if (payload?.error) {
    throw new Error(payload?.error[0]?.description);
  }

  return payload;
};

export const getHolidayImage = async (poolId) => {
  const requestPath = `${baseUrl}/public-holidays/${poolId}/image`;

  try {
    const { payload } = await getRequest(requestPath, false, "blob");

    if (!payload) {
      return null;
    }

    // Create a blob URL that can be used as image src
    // Note: This URL must be revoked with URL.revokeObjectURL() when no longer needed
    const imageUrl = URL.createObjectURL(payload);

    return imageUrl;
  } catch (error) {
    return null;
  }
};

export default getPublicHolidays;
